import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Patient } from 'src/app/patient-management/models/patient.interface';
import { PatientService } from 'src/app/patient-management/services/patient.service';
import { Client } from 'src/app/client-management/models/client.interface';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-search-patients',
    templateUrl: './search-patients.component.html',
    styleUrls: ['./search-patients.component.scss']
})
export class SearchPatientsComponent implements OnInit, OnChanges, OnDestroy {

    @Input() patient: Patient;
    @Input() client: Client;
    @Output() selectedPatient = new EventEmitter<Patient>();
    @Input() disabled: boolean;
    @Input() preventAutoFocus: boolean = false;

    patientSearch = new FormControl('');
    patientResults: Patient[] = [];
    patientOptions: Patient[] = [];
    subscription: Subscription = new Subscription();

    constructor(
        public patientService: PatientService
    ) { }

    ngOnInit() {
        if (this.patient && this.patient.id !== '') {
            this.patientSearch.patchValue(this.patient.name);
        }
        if (this.disabled) {
            this.patientSearch.disable();
        }

        this.subscription.add(
            this.patientSearch.valueChanges.pipe(debounceTime(300)).subscribe(_ => {
                this.searchPatients(this.patientSearch.value);
            })
        );
        
        if (this.isClientSelected) {
            this.getPatientsByClientId();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.client && this.isClientSelected) {
            this.getPatientsByClientId();
        }

        if (changes.patient && this.patientSearch) {
            if (this.patient && this.patient.id !== '') {
                this.patientSearch.patchValue(this.patient.name, {emitEvent: false});
            } else {
                this.patientSearch.patchValue('', {emitEvent: false});
            }
        }
        
        if (changes.disabled && this.patientSearch) {
            if (this.disabled) {
                this.patientSearch.disable();
            } else {
                this.patientSearch.enable();
            }
        }
    }

    searchPatients(patientSearch: string) {
        if (patientSearch === '') {
            this.patient = new Patient();
            this.selectedPatient.emit(this.patient);
        }
        if (this.isClientSelected && this.client.patients != null) {
            this.patientOptions = this.client.patients
                .filter(patient => patient.name.toLowerCase().includes(patientSearch.toLowerCase()));
        } else if (this.isClientSelected) {
            if (patientSearch === '') {
                this.getPatientsByClientId();
            } else {
                this.patientOptions = [];
                this.patientResults.forEach(patient => {
                    if (patient.name.toLowerCase().includes(patientSearch.toLowerCase())) {
                        this.patientOptions.push(patient);
                    }
                })
            }
        }
        else {
            this.patientService.searchPatients(patientSearch).subscribe(
                response => {
                    if (response.length > 0) {
                        this.patientOptions = response;
                    }
                }
            );
        }
    }

    getPatientsByClientId() {
        this.patientService.getPatientSummaryByClientId(this.client.id).subscribe(
            response => {
              this.patientResults = response;
              this.patientOptions = response;
        });
    }

    selectPatient(patient: Patient) {
        this.patient = patient;
        this.patientSearch.patchValue(this.patient.name, {emitEvent: false});
        this.selectedPatient.emit(patient);
    }

    get isClientSelected() {
        return this.client && this.client.id;
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
